import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../reducers";
import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { updateEditorialTemplate } from "../../api/editorial";
import { EditorialTemplate } from "../../domain/domain";
import { UiActionType } from "../../reducers/ui.reducer";
import { EditorialTemplatesActionType } from "../../reducers/editorialTemplates.reducer";
import { ConfirmationDialog } from "../Dialogs/ConfirmationDialog";
import TextEditor from "../TextEditor/TextEditor";


const EditorialTemplateEditor : React.FC = () => {

    const selectedEditorialTemplate = useSelector((app: ApplicationState) => app.editorialTemplates.selectedEditorialTemplate);
    const [loading, setLoading] = useState<boolean>(false);
    const [saveEditorialConfirmationDialogOpen, setSaveEditorialConfirmationDialogOpen] = useState<boolean>(false);
    const [editorState, setEditorState] = useState<string>("");
    const dispatch = useDispatch();

    useEffect(() => {
        if(!selectedEditorialTemplate){
            setEditorState("");
        } else{
            setEditorState(selectedEditorialTemplate.content);
        }
    }, [selectedEditorialTemplate])

    return(
        <Grid container direction="column" className="flex-gap-2">
            <ConfirmationDialog
                open={saveEditorialConfirmationDialogOpen}
                title=""
                contentText="Are you sure you want to save this editorial template?"
                handleNo={() => {
                    setSaveEditorialConfirmationDialogOpen(false);
                }}
                handleYes={() => {
                    if(!selectedEditorialTemplate){
                        return;
                    }
                    let newEditorialTemplate : EditorialTemplate = {
                        ...selectedEditorialTemplate,
                        content : editorState,
                    };
                    setLoading(true);
                    setSaveEditorialConfirmationDialogOpen(false);
                    updateEditorialTemplate(newEditorialTemplate).then(response => {
                        dispatch({ type: EditorialTemplatesActionType.EDITORIAL_TEMPLATE_UPDATED, editorialTemplate: response.data });
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Changes saved", severity: "success" } });
                        setLoading(false);
                    }).catch(error => {
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Could not save changes", severity: "error" } });
                        setLoading(false);
                        console.error(error);
                    })
                }}
            />
            <Grid item>
                {selectedEditorialTemplate !== undefined &&
                    <div style={{border: '1px solid #ccc', padding: 16}}>
                        <TextEditor
                            showToolbar={true}
                            showEditorialTypes={false}
                            readOnly={false}
                            showEditorialButtons={true}
                            editorStyle={{ maxHeight: 500 }}
                            html={editorState}
                            onChange={(newHtml: string) => {
                                setEditorState(newHtml);
                            }} />   
                    </div>
                }
                {selectedEditorialTemplate === undefined &&
                    <div>
                        <Typography variant='h3'>No editorial templates found for selected editorial type</Typography>
                    </div>
                }
            </Grid>
            {selectedEditorialTemplate !== undefined &&
                <Grid item style={{marginTop: 16}}>
                    <Button 
                        variant='contained'
                        color='primary'
                        disabled={loading}
                        onClick={() => {
                            setSaveEditorialConfirmationDialogOpen(true);
                    }}>
                        Save
                    </Button>
                </Grid>
            }
        </Grid>
    )

}

export default EditorialTemplateEditor;
